<template>
  <div>
    <div v-for="connector in connectors">
      <template v-if="connector.connector === MailifyConnectorEnum.AZURE">
        <h3>Office365 E-mailkoppeling</h3>
        <template v-if="connector.configured">
          <div v-for="connectorSetting in connector.settings">
            <AzureConfigurationComponent v-bind:connector-setting="connectorSetting"/>
          </div>
        </template>
        <template v-else>
          <a-button v-on:click="onConfigureConnectorClick(connector)">Instellen</a-button>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import MailifyConnectorEnum from '~/enums/MailifyConnectorEnum'
import { mapGetters } from 'vuex'
import store from '../store'
import mailApi from '~/api/mailify'
import AzureConfigurationComponent from './AzureConfigurationComponent'

export default {
  name: 'ConfigurationPageComponent',
  components: {
    AzureConfigurationComponent
  },
  data () {
    return {
      internal: 1,
      connectors: null,
      connectorsWithMailboxes: null,
      MailifyConnectorEnum
    }
  },
  computed: {
    ...mapGetters({
      name: '$_mailify/name',
    })
  },
  created () {
    const STORE_KEY = '$_mailify'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    mailApi.getConnectors().then(connectors => {
      this.connectors = connectors
    })
    mailApi.getMailboxes().then(connectorsWithMailboxes => {
      this.connectorsWithMailboxes = connectorsWithMailboxes
    })
  },
  methods: {
    mailboxesByConnector (connector) {
      if (this.connectorsWithMailboxes === null) {
        return []
      }

      return this.connectorsWithMailboxes[connector]
    },
    onConfigureConnectorClick (connector) {
      window.location = connector.link
    }
  }
}
</script>

<style scoped>

</style>